import { useState } from 'react';
import { useForm, Controller, SubmitHandler } from 'react-hook-form';
import { isAxiosError } from 'axios';
import axios from '../../api/axios';
import MessageBox from '../MessageBox/MessageBox';
import TextField from '@mui/material/TextField';
import logo from '../../assets/yapa-logo.png';
import './ChangePasswordPage.css';
import { Email } from '@mui/icons-material';
import { Button } from '@mui/material';

interface IFormInput {
  email: string;
}

const RESET_URL = '/auth/reset';

const EMAIL_REGEX = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

const RESET_BUTTON_TITLE = 'Reset hasła';
const CONNECTION_ERROR_MESSAGE = 'Nie można nawiązać połączenia z serwerem!';
const INVALID_CREDENTIALS_MESSAGE = 'Podane dane są nieprawidłowe!';
const UNKNOWN_ERROR_MESSAGE = 'Nieznany błąd!';
const EMAIL_SENT_MESSAGE = 'Sprawdź swoją skrzynkę e-mailową w celu zmiany hasła.';

const ChangePasswordPage = () => {
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [emailEntered, setEmailEntered] = useState(false); // Dodajemy stan, aby śledzić, czy e-mail został wprowadzony

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<IFormInput>({
    defaultValues: {
      email: '',
    },
  });

  const onSubmit: SubmitHandler<IFormInput> = async (data) => {
    const { email } = data;
    try {
      await axios.post(RESET_URL, JSON.stringify({ email }), {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      });

      setErrorMsg(EMAIL_SENT_MESSAGE);
      setEmailEntered(true); // Ustawiamy stan na true po poprawnym wprowadzeniu e-maila
    } catch (error) {
      if (isAxiosError(error)) {
        if (!error?.response) {
          setErrorMsg(CONNECTION_ERROR_MESSAGE);
        } else if (error.response?.status) {
          setErrorMsg(INVALID_CREDENTIALS_MESSAGE);
        }
      } else {
        setErrorMsg(UNKNOWN_ERROR_MESSAGE);
      }
    }

    setOpen(true);
  };

  return (
      <div className="login-container">
        <img src={logo} width={250} alt="Logo YAPA" />
        <div className="login-content">
          <div>Zmiana hasła</div>
          {/* Dodajemy warunek, aby wyświetlić formularz tylko jeśli e-mail nie został jeszcze wprowadzony */}
          {!emailEntered ? (
              <form className="login-form" onSubmit={handleSubmit(onSubmit)}>
                <Controller
                    name="email"
                    control={control}
                    rules={{
                      required: true,
                      pattern: EMAIL_REGEX,
                    }}
                    render={({ field }) => (
                        <TextField
                            type="text"
                            label="E-mail"
                            {...field}
                            error={errors.email ? true : false}
                            helperText={errors.email ? 'Niepoprawny e-mail' : ''}
                        />
                    )}
                />
                <Button
                    variant="contained"
                    type="submit"
                    size="large"
                    sx={{ marginTop: '20px' }}
                >
                  {RESET_BUTTON_TITLE}
                </Button>
              </form>
          ) : (
              // Jeśli e-mail został już wprowadzony, wyświetlamy inny komunikat
              <div className="message-container">
                <p>
                  Wejdź na wcześniej wpisaną skrzynkę e-mail, aby sfinaizować zmianę hasła.
                </p>
              </div>
          )}
        </div>
        <MessageBox
            open={open}
            setOpen={setOpen}
            message={errorMsg}
            error={errorMsg !== EMAIL_SENT_MESSAGE}
        />
      </div>
  );
};

export default ChangePasswordPage;
